<template>
  <div class="about">
    <h2>A site for events to better the word.</h2>
  </div>
</template>
